import "./App.css";
import React, { useEffect } from "react";
import Lenis from "lenis";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import WhySection from "./components/WhySection";
import FeaturesSection from "./components/FeaturesSection";
import IntegrationsSection from "./components/IntegrationsSection";
import TestimonialsSection from "./components/TestimonialsSection";
import PricingSection from "./components/PricingSection";
import FaqSection from "./components/FaqSection";
import ContactSection from "./components/ContactSection";
import PartnerSection from "./components/PartnerSection";
import FooterSection from "./components/FooterSection";
import LegalPage from "./components/LegalPage";

function App() {
  const path = window.location.pathname;
  const legalType =
    path === "/impressum"
      ? "impressum"
      : path === "/datenschutz"
        ? "datenschutz"
        : path === "/data-deletion" || path === "/datenloeschung"
          ? "deletion"
          : path === "/agb"
            ? "agb"
            : null;

  useEffect(() => {
    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    if (prefersReducedMotion) {
      return undefined;
    }

    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      anchors: {
        offset: -88,
        duration: 1.35,
      },
    });

    let frameId;
    const raf = (time) => {
      lenis.raf(time);
      frameId = requestAnimationFrame(raf);
    };

    frameId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(frameId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App min-h-screen bg-[#EDF1F8] text-[#16263F] antialiased">
      <Navbar />
      <main>
        {legalType ? (
          <>
            <LegalPage type={legalType} />
            <FooterSection />
          </>
        ) : (
          <>
            <Hero />
            <WhySection />
            <FeaturesSection />
            <IntegrationsSection />
            <TestimonialsSection />
            <PricingSection />
            <PartnerSection />
            <FaqSection />
            <ContactSection />
            <FooterSection />
          </>
        )}
      </main>
    </div>
  );
}

export default App;
